import dataURLtoBlob from "blueimp-canvas-to-blob";

const FILE_API_BASE_URL = '/api/file';
const getUpdateGalleryUrl = (activityId) => `/api/inventory-activity/${encodeURIComponent(activityId)}/gallery`;
const GET_INVENTORY_UPLOAD_URL = `${FILE_API_BASE_URL}/v2/inventory/upload-url`;
const GET_GALLERY_UPLOAD_URL = `${FILE_API_BASE_URL}/gallery/upload-url`;
const GET_LISTING_IMAGES_URL = `${FILE_API_BASE_URL}/listing-images/upload-url`
const GET_LEGAL_AGREEMENTS_URL = `${FILE_API_BASE_URL}/legal-agreements/upload-url`

const handleResponse = (response) => {
  if (!response.ok) {
    throw Error(`${response.status} - ${response.statusText}`);
  }
  return response;
}

const getUploadUrl = async (url, params) => {
  try {
    const response = await fetch(url + '?' + new URLSearchParams(params));
    return await handleResponse(response).json();
  } catch (error) {
    throw Error("Failed to retrieve upload URL");
  }
}

const uploadFile = async (file, uploadUrl, contentType) => {
  try {
    const response = await fetch(uploadUrl, {
      method: "PUT",
      headers: {
        "Content-Type": contentType
      },
      body: file
    });
    handleResponse(response);
  } catch (e) {
    throw Error("Failed to upload file");
  }
}

export const uploadInventoryImageBlob = async (inventoryId, file, fileName, contentType) => {
  const { uploadUrl, fileName: responseFileName } = await getUploadUrl(GET_INVENTORY_UPLOAD_URL,
    {
      fileName,
      inventoryId,
      contentType
    });

  await uploadFile(file, uploadUrl, contentType);
  return responseFileName;
}

export const uploadInventoryImage = async (inventoryId, fileDataUrl, fileName, contentType) => {
  return uploadInventoryImageBlob(
    inventoryId,
    dataURLtoBlob(fileDataUrl),
    fileName,
    contentType
  );
}

export const uploadGalleryImage = async (locationId, fileDataUrl, fileName, contentType) => {
  const { uploadUrl, fileName: responseFileName } = await getUploadUrl(GET_GALLERY_UPLOAD_URL,
    {
      fileName,
      locationId,
      contentType
    });

  await uploadFile(dataURLtoBlob(fileDataUrl), uploadUrl, contentType);
  return responseFileName;
}

export const uploadListingImage = async (fileDataUrl, fileName, contentType) => {
  const { uploadUrl, fileName: responseFileName } = await getUploadUrl(GET_LISTING_IMAGES_URL,
    {
      fileName,
      contentType
    });

  await uploadFile(dataURLtoBlob(fileDataUrl), uploadUrl, contentType);
  return responseFileName;
}

export const uploadCompanyProfileImage = async (file, fileName, contentType) => {
  const { uploadUrl, fileName: responseFileName } = await getUploadUrl(GET_LISTING_IMAGES_URL,
    {
      fileName,
      contentType
    });

  await uploadFile(file, uploadUrl, contentType);
  return responseFileName;
}

export const uploadLegalAgreement = async (file, fileName, contentType) => {
  const { uploadUrl, fileName: responseFileName } = await getUploadUrl(GET_LEGAL_AGREEMENTS_URL,
    {
      fileName,
      contentType
    });

  await uploadFile(file, uploadUrl, contentType);
  return responseFileName;
}

export const deleteFile = async (fileName) => {
  await fetch(FILE_API_BASE_URL + '?' + new URLSearchParams({ fileName }), { method: "DELETE" })
}


// J10: updated to use new path-param endpoint; activityId is now a path param
export const updateGallery = async (activityId, galleryFiles) => {
  const response = await fetch(getUpdateGalleryUrl(activityId), {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "Accept": "application/json",
    },
    body: JSON.stringify({ galleryFiles }),
  });
  return handleResponse(response);
}
